export const minASNLength = 5;
export const maxASNLength = 7;
export const minShipmentLength = 5;
export const maxShipmentLength = 7;
export const minZendeskLength = 5;
export const maxZendeskLength = 7;
export const DSKULength = 11;
export const maxWarehouseLength = 15;
export const maxASANALength = 80;

export const validASNPattern = /^\d{5,7}$/;
export const validShipmentPattern = /^\d{5,7}$/;
export const validZendeskPattern = /^\d{5,7}$/;
export const validWarehousePattern =
  /^([A-Za-z]{3}_[A-Za-z]{3})|(DM_[_A-Z0-9]+)$/;
export const validLowerCaseWordPattern = /^[A-Za-z]+$/;
export const validLowerCaseIDPattern = /^[0-9A-Za-z]+$/;
export const validDateFormat = /^\d{4}-[0-1][0-9]-[0-3][0-9]$/;
export const validCurrencyPattern = /^-?\d+(\.\d{1,2})?$/;

export const hasLowerCase = /[a-z]/;
export const hasUpperCase = /[A-Z]/;

// https://app.asana.com/0/1147658396884857/1199546009653140/f
// export const validASANAPattern = /^https\:\/\/app\.asana\.com\/[0-9]]\/[0-9]+\/[0-9]+\/f$/;
export const validASANAPattern =
  /^https:\/\/app\.asana\.com\/[0-9]\/[0-9]+\/[0-9]+\/f$/;

export const validDSKU = /^D\w{10}$/;
